module.exports = __webpack_public_path__ + "media/images/pages/fcr/doctor-2-118b76a3fd5cb44c25841ffe69d04135.png";